import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import Container from "../../components/shared/Container";
import UserSidebar from "../shared/UserSidebar";
import FrontFooter from "../../shared/FrontFooter";
import FrontHeader from "../../shared/FrontHeader";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setLanguage } from "../../redux/slice/languageSlice";
import { useDispatch } from "react-redux";
import InnerPanel from "../shared/InnerPanel";
import { useQuery } from "@tanstack/react-query";
import { eventDetails } from "../../services/eventService";
import { langConfig } from "../../config/LangConfig";
import {
  organizationTeamDetails,
  organizationTeamList,
} from "../../services/organizationService";
import PromoterInnerPanel from "../shared/PromoterInnerPanel";

const FrontPromoterLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { lang: paramsLang } = useParams();
  const { lang } = useSelector((state) => state?.langProvider);
  const { promoterId } = useParams();

  useEffect(() => {
    if (langConfig?.includes(paramsLang)) {
      if (paramsLang !== lang) {
        dispatch(setLanguage(paramsLang));
        localStorage.setItem("lang", paramsLang);
      }
    } else {
      const save_lang = localStorage.getItem("lang");
      let uri_sagement = location?.pathname?.split("/");
      uri_sagement[1] = save_lang || "en";
      navigate(uri_sagement.join("/"));
    }
  }, [paramsLang, lang]);

  const {
    data: promoterDetailsData,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["promoter-event-details", promoterId],
    queryFn: async () => {
      const res = await organizationTeamDetails({
        id: promoterId,
        type: "front",
      });
      return res;
    },
    enabled: !!promoterId,
  });

  // ✅ Sidebar toggle state
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // ✅ Auto-close sidebar on route change
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    // <div className="bg-magnolia">
    //   <FrontHeader />
    //   <Container className={"px-0 items-start gap-4"}>
    //     <div className="flex-shrink-0 w-72 py-6 h-[calc(100vh-6rem)] sticky top-24 z-[10]">
    //       <PromoterInnerPanel
    //         promoterDetails={promoterDetailsData?.data || {}}
    //         selectedLanguage={lang}
    //       />
    //     </div>
    //     <div className="w-full flex-shrink py-4 px-4">
    //       <Outlet
    //         context={{
    //           promoter: promoterDetailsData,
    //           promoterLoading: isLoading || isFetching,
    //           selectedLanguage: lang,
    //         }}
    //       />
    //     </div>
    //   </Container>
    //   <FrontFooter />
    // </div>
    <div className="bg-magnolia min-h-screen flex flex-col">
      <FrontHeader />

      {/* Mobile/iPad Toggle Button */}
      <div className="lg:hidden flex items-center justify-between px-4 py-3 bg-white shadow sticky top-24 z-40">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-md hover:bg-gray-100 transition"
        >
          <span className="text-deep-purple text-2xl"><i class="fa-regular fa-filter-list"></i></span>
        </button>
        {/* <span className="font-semibold text-gray-700">
          {typeof promoterDetailsData?.data?.eventData?.title === "object"
            ? promoterDetailsData?.data?.eventData?.title?.en ||
              Object.values(promoterDetailsData?.data?.eventData?.title)[0] ||
              "Promoter Details"
            : promoterDetailsData?.data?.eventData?.title || "Promoter Details"}
        </span> */}
      </div>

      <Container className="relative flex flex-1 px-0 items-start gap-4">
        <div
          className={`fixed lg:sticky top-24 left-0 z-30 w-72 bg-white transition-transform duration-300 ease-in-out py-6 h-[calc(100vh-6rem)]
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
          lg:translate-x-0`}
        >
          <PromoterInnerPanel
            promoterDetails={promoterDetailsData?.data || {}}
            selectedLanguage={lang}
          />
        </div>

        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-20 lg:hidden"
            onClick={toggleSidebar}
          ></div>
        )}

        <div className="w-full flex-shrink pt-5 lg:pt-0 py-4 px-4 md:ml-0">
          <Outlet
            context={{
              promoter: promoterDetailsData,
              promoterLoading: isLoading || isFetching,
              selectedLanguage: lang,
            }}
          />
        </div>
      </Container>

      <FrontFooter />
    </div>
  );
};

export default FrontPromoterLayout;
